<script setup lang="ts">
import vPreloadImg from '@/ts/directives/v-preload-img';
import model from '@/ts/model';
import { computed } from 'vue';
const bgCasino = import.meta.glob('@/assets/bg.*', { eager: true, query: '?url', import: 'default' });
const bgMobileCasino = import.meta.glob('@/assets/bg-mobile.*', { eager: true, query: '?url', import: 'default' });
const bgLive = import.meta.glob('@/assets/bg-live.*', { eager: true, query: '?url', import: 'default' });
const bgMobileLive = import.meta.glob('@/assets/bg-live-mobile.*', { eager: true, query: '?url', import: 'default' });
const bg = computed<Record<string, unknown>>(() => {
    switch(model.view){
        case 'live-casino' : return model.isMobile ? bgMobileLive : bgLive;
    }
    return model.isMobile ? bgMobileCasino : bgCasino;
});
</script>

<template>
	<template v-if="model.view != 'gameplay'">
		<img class="background" v-preload-img="bg">
	</template>
</template>

<style lang="scss" scoped>
	@use '@/scss/shared';
	.background{
		position: fixed;
		width: 100vw;
		height: 100vh;
		object-fit: cover;
		object-position: top center;
		z-index: 0;
		animation-fill-mode: forwards;
		animation-duration: .25s;
		animation-name: background-display;
		@keyframes background-display {
			from{
				opacity: 0;
			}
			to{
				opacity: 1;
			}
		}
	}
</style>